import { Component, inject, OnInit, HostListener, ElementRef, signal, computed } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CurrentUserService } from '../../../services/current-user.service';
import { ProfileService } from '../../../services/profile-service';
import { UserProfileVTO } from '../../../services/profile-service.model';
import { LanguageService } from '../../../services/language.service';
import { NotificationsDropdown } from '../../user-dashboard-component/notifications-dropdown/notifications-dropdown';
import { NotificationService } from '../../../services/notifications/notifications.service';
import { NotificationType } from './header.model';
import { timeAgo } from '../../user-dashboard-component/notifications-dropdown/utils/timeago';
import { WebsocketService } from '../../../services/notifications/WebSocketService';

@Component({
  selector: 'app-admin-header',
  standalone: true,
  imports: [RouterModule, CommonModule, NotificationsDropdown],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class AdminHeader implements OnInit {
  private currentUserService = inject(CurrentUserService);
  private profileService = inject(ProfileService);
  private router = inject(Router);
  private languageService = inject(LanguageService);
  private elementRef = inject(ElementRef);
  private notificationService = inject(NotificationService);

  userInitial = signal<string>('A');
  userFullname = signal<string>('Admin');
  isDropdownOpen = signal<boolean>(false);
  currentLocale = signal<string>('en');

  isNotificationsDropdownOpen = signal<boolean>(false);
  notifications = signal<NotificationType[]>([]);

  hasUnreadNotifications = computed(() => {
    return this.notifications().some((n) => !n.isRead);
  });

  ngOnInit() {
    this.loadUserData();
    this.currentLocale.set(this.languageService.getCurrentLocale());
  }

  loadUserData() {
    this.profileService.getUserProfile().subscribe({
      next: (user: UserProfileVTO) => {
        const fullname = user.firstName + ' ' + user.lastName;
        this.userFullname.set(fullname);
        this.userInitial.set(fullname.charAt(0).toUpperCase());
      },
      error: (err) => {
        console.error('Failed to load user data:', err);
        this.userInitial.set('A');
      },
    });
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isDropdownOpen() && !this.elementRef.nativeElement.contains(event.target)) {
      this.isDropdownOpen.set(false);
    }
    const target = event.target as HTMLElement;
    const notificationsContainer = target.closest('.notifications-container');
    if (this.isNotificationsDropdownOpen() && !notificationsContainer) {
      this.isNotificationsDropdownOpen.set(false);
    }
  }

  toggleDropdown(event: Event) {
    event.stopPropagation();
    this.isDropdownOpen.set(!this.isDropdownOpen());
  }

  closeDropdown() {
    this.isDropdownOpen.set(false);
  }

  onProfile() {
    this.isDropdownOpen.set(false);
    this.router.navigate(['/admin/profile']);
  }

  onLogout() {
    this.currentUserService.logout();
    this.isDropdownOpen.set(false);
    this.router.navigate(['/login']);
  }

  toggleLanguage() {
    this.languageService.toggleLocale();
  }

  onNotificationsClick(event: Event) {
    event.stopPropagation();
    this.isNotificationsDropdownOpen.set(!this.isNotificationsDropdownOpen());
  }

  onNotificationsClose() {
    this.isNotificationsDropdownOpen.set(false);
  }

  // onMarkAllRead() {
  //   this.notifications.update((notifications) => notifications.map((n) => ({ ...n, isRead: true })));
  //   // this.notificationService.
  // }
}
